import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CATEGORY_LABELS } from "../lib/api";

export const ArticleCard = ({ article, index = 0, size = "default" }) => {
  const tall = size === "tall";
  const wide = size === "wide";

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 6) * 0.08, ease: [0.4, 0, 0.2, 1] }}
      className={`${wide ? "sm:col-span-2" : ""} ${tall ? "lg:row-span-2" : ""}`}
    >
      <Link
        to={`/article/${article.slug}`}
        data-testid={`article-card-${article.slug}`}
        className="group block relative overflow-hidden rounded-lg border border-white/10 bg-surface h-full"
      >
        <div className={`relative overflow-hidden ${tall ? "aspect-[3/4]" : "aspect-[4/3]"}`}>
          <img
            src={article.hero_image}
            alt={article.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
          <span className="absolute top-4 left-4 font-body text-[10px] uppercase tracking-[0.22em] text-white bg-crimson/90 px-2.5 py-1 rounded-full">
            {CATEGORY_LABELS[article.category] || article.category}
          </span>
        </div>

        <div className="absolute bottom-0 inset-x-0 p-6">
          <p className="font-body text-[11px] uppercase tracking-[0.2em] text-crimson mb-2">
            {article.kicker}
          </p>
          <h3 className="font-serif text-xl sm:text-2xl leading-snug text-white group-hover:text-white/90">
            {article.title}
          </h3>
          <p className="mt-2 font-body text-sm text-white/60 line-clamp-2">
            {article.subtitle}
          </p>
          <div className="mt-4 flex items-center gap-3 font-body text-xs text-white/40">
            <span>{article.author}</span>
            <span className="h-1 w-1 rounded-full bg-white/30" />
            <span>{article.read_time}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
